<template>
  <div class="menu-container">
    <el-image :src="src_logo"
              class="logo"
              fit="fill"></el-image>
    <span class="home-title"
          @click="goHome">美团 · 地图开放平台</span>
    <el-dropdown style="margin-left: 60px"
                 trigger="hover"
                 @visible-change="changeServiceState"
                 placement="bottom">
      <div class="el-dropdown-link">
        <span>服务介绍</span>
        <img v-if="!showServiceFlag"
             style="margin-left:8px"
             src="../assets/img/icon/icon_down.svg">
        <img v-else
             style="margin-left:8px"
             src="../assets/img/icon/icon_up.svg">
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <router-link to="/service/search">
            <div>搜索</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/service/routing">
            <div>路线规划</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/service/geo">
            <div>地理编码</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/service/regeo">
            <div>位置描述</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/service/division">
            <div>行政区域查询</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/service/mapmatch">
            <div>地图匹配</div>
          </router-link>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown style="margin-left: 42px"
                 placement="bottom"
                 @visible-change="changeSupportState">
      <div class="el-dropdown-link">
        <span>开发支持</span>
        <img v-if="!showSupportFlag"
             style="margin-left:8px"
             src="../assets/img/icon/icon_down.svg">
        <img v-else
             style="margin-left:8px"
             src="../assets/img/icon/icon_up.svg">
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <router-link to="/support/search">
            <div>搜索</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/support/routing">
            <div>路线规划</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/support/geo">
            <div>地理编码</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/support/regeo">
            <div>位置描述</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/support/division">
            <div>行政区域查询</div>
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link to="/support/mapmatch">
            <div>地图匹配</div>
          </router-link>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- <div class="console-container">
      <router-link to="/console">
        <span style="height:60px;line-height:60px; color:rgba(255,255,255,0.72)">控制台</span>
      </router-link>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      src_logo: require('../assets/img/meituan-logo.png'),
      showServiceFlag: false,
      showSupportFlag: false
    };
  },
  methods: {
    goHome() {
      // this.$rou
      this.$router.push('/');
    },
    changeServiceState() {
      this.showServiceFlag = !this.showServiceFlag;
    },
    changeSupportState() {
      this.showSupportFlag = !this.showSupportFlag;
    }
  }
};
</script>

<style lang="less" scoped>
.el-dropdown-menu {
  width: 200px !important;
  box-shadow: 0 6px 18px 0 rgba(0, 0, 0, 0.12) !important;
  border-radius: 12px !important;
}
.el-dropdown-menu__item {
  padding-left: 30px !important;
  height: 36px !important;
}
/deep/ .el-dropdown-menu__item:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  color: #000 !important;
  font-weight: 400 !important;
}
// .menu-container .el-dropdown .el-dropdown-link[data-v-9b39c422] {
//   color: rgba(0, 0, 0, 1);
//   background: rgba(0, 0, 0, 0.03);
// }
.menu-container {
  border-bottom: none !important;
  width: 1200px;
  height: 60px;
  display: flex;
  align-items: center;
  .logo {
    width: 25px;
    height: 25px;
    // margin-top: 18px;
    float: left;
  }
  .home-title {
    font-size: 18px;
    color: #fff;
    font-family: MeituanType-Regular;
    line-height: 60px;
    float: left;
    // margin: 0 120px 0 10px;
    margin-left: 5px;
  }
  .home-title:hover {
    cursor: pointer;
  }
  .el-dropdown {
    .el-dropdown-link {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.72);
      font-weight: 400;
      line-height: 20px;
      display: flex;
      align-items: center;
    }
  }
  .console-container {
    display: flex;
    align-items: center;
    margin-left: 600px;
    height: 100%;
  }
}
</style>
